import { jsxs as i, jsx as t } from "react/jsx-runtime";
import { useState as _, useEffect as O } from "react";
import { useBreakpoint as W, Breakpoints as V, NextgenImage as z, LoaderType as L, Button as C, ButtonStyles as y, Theme as G, ButtonSize as v, ButtonIconPosition as M, ButtonWidth as r, GenericLink as E } from "@nextgen-web-framework/all";
import R from "../SkeletonLoader/SkeletonLoader.js";
import x from "../portal/Portal.js";
import { getGradientClass as D } from "../../utils/themeColor.js";
import U from "./components/VideoModal.js";
import { Gradient as F } from "./types/propsTypes.js";
import '../../assets/VideoBanner.css';const H = "#ffffff", Y = "#396e75", A = "#e5fdff", j = "#546223", $ = "#f0fae5", K = "#a65523", X = "#fff1e8", q = "#7f3e3e", J = "#ffe2e2", Q = "#62625a", Z = "#f8f8e7", B = "#38539a", P = "#707070", ee = "#c8f8d1", te = "#87c9c8", ae = "#5291b1", oe = "rgba(82, 145, 177, 0.1019607843)", ie = "#445685", re = "#181d61", de = "rgba(24, 29, 97, 0.1019607843)", ne = "#5969d6", le = "#ea999d", ce = "#b6577e", _e = "rgba(182, 87, 126, 0.1019607843)", ge = "#7e3e80", se = "#1e247f", me = "rgba(30, 36, 127, 0.1019607843)", be = "#da7600", he = "#107f47", ke = "#d91734", ue = "_html_iki5o_38", fe = "_blueGradient_iki5o_249", Ve = "_darkgreenGradient_iki5o_252", ze = "_orangeGradient_iki5o_255", Ce = "_grayGradient_iki5o_258", ye = "_redGradient_iki5o_261", a = {
  amwayWhite: H,
  darkBlue: Y,
  lightBlue: A,
  darkGreen: j,
  lightGreen: $,
  darkOrange: K,
  lightOrange: X,
  darkRed: q,
  lightRed: J,
  darkYellow: Q,
  lightYellow: Z,
  darkPurple: B,
  darkGrayOnWhite: P,
  dataVizColor1: ee,
  dataVizColor2: te,
  dataVizColor3: ae,
  dataVizColor3Background: oe,
  dataVizColor4: ie,
  dataVizColor5: re,
  dataVizColor5Background: de,
  dataVizColor6: ne,
  dataVizColor7: le,
  dataVizColor8: ce,
  dataVizColor8Background: _e,
  dataVizColor9: ge,
  dataVizColor10: se,
  dataVizColor10Background: me,
  dataVizAlertOrange: be,
  dataVizSuccessGreen: he,
  dataVizWarningRed: ke,
  "no-visible": "_no-visible_iki5o_34",
  html: ue,
  "theme-border-dark-red": "_theme-border-dark-red_iki5o_143",
  "theme-border-dark-blue": "_theme-border-dark-blue_iki5o_147",
  "theme-border-dark-orange": "_theme-border-dark-orange_iki5o_151",
  "theme-border-dark-green": "_theme-border-dark-green_iki5o_155",
  "theme-border-dark-purple": "_theme-border-dark-purple_iki5o_159",
  "theme-border-dark-gray": "_theme-border-dark-gray_iki5o_163",
  "theme-border-light-red": "_theme-border-light-red_iki5o_167",
  "theme-border-light-blue": "_theme-border-light-blue_iki5o_171",
  "theme-border-light-orange": "_theme-border-light-orange_iki5o_175",
  "theme-border-light-green": "_theme-border-light-green_iki5o_179",
  "theme-border-light-purple": "_theme-border-light-purple_iki5o_183",
  "theme-border-light-gray": "_theme-border-light-gray_iki5o_187",
  "theme-gradient-red": "_theme-gradient-red_iki5o_191",
  "theme-gradient-blue": "_theme-gradient-blue_iki5o_195",
  "theme-gradient-orange": "_theme-gradient-orange_iki5o_199",
  "theme-gradient-green": "_theme-gradient-green_iki5o_203",
  "theme-gradient-purple": "_theme-gradient-purple_iki5o_207",
  "video-banner-container": "_video-banner-container_iki5o_211",
  "video-banner-bg-image": "_video-banner-bg-image_iki5o_227",
  "video-player-container": "_video-player-container_iki5o_231",
  "video-banner-skeleton-wrapper": "_video-banner-skeleton-wrapper_iki5o_240",
  "video-player": "_video-player_iki5o_231",
  blueGradient: fe,
  darkgreenGradient: Ve,
  orangeGradient: ze,
  grayGradient: Ce,
  redGradient: ye,
  "video-banner-bottom-content-container": "_video-banner-bottom-content-container_iki5o_264",
  "video-banner-details": "_video-banner-details_iki5o_276",
  "video-banner-logo-container": "_video-banner-logo-container_iki5o_285",
  "video-banner-logo": "_video-banner-logo_iki5o_285",
  "video-banner-title": "_video-banner-title_iki5o_295",
  "video-banner-footer-button": "_video-banner-footer-button_iki5o_309"
}, Oe = (e) => {
  var b, h, k, u, f;
  const d = W(), [n, N] = _(!0), [g, T] = _(!1), l = (b = e.images) == null ? void 0 : b.find((c) => c.viewport.includes(d)), o = (h = e.brandLogo) == null ? void 0 : h.find((c) => c.viewport.includes(d)), S = e.linearGradient ? D(e.linearGradient) : e.overlayGradient ? F[e.overlayGradient] : "", s = [V.SM, V.XS].includes(d), [p, w] = _(!0);
  O(() => {
    w(!1);
  }, []);
  const I = () => N(!1), m = () => {
    T(!g);
  };
  return /* @__PURE__ */ i("div", { className: a["video-banner-container"], "data-testid": "video-banner-testid", "data-pod-name": "commerce", children: [
    !e.backgroundVideoUrl && l ? /* @__PURE__ */ t(
      z,
      {
        src: l.url,
        alt: l.altText,
        className: a["video-banner-bg-image"],
        loading: "eager",
        loaderType: L.CONTENTSTACK
      }
    ) : "",
    /* @__PURE__ */ i("div", { className: a["video-player-container"], children: [
      n && /* @__PURE__ */ t("div", { className: a["video-banner-skeleton-wrapper"], children: /* @__PURE__ */ t(R, { isRoundCorner: !1 }) }),
      p && e.backgroundVideoUrl ? "" : /* @__PURE__ */ t(
        "video",
        {
          className: a["video-player"],
          style: n ? { visibility: "hidden" } : {},
          autoPlay: !0,
          loop: !0,
          muted: !0,
          playsInline: !0,
          id: "video-banner-id",
          "data-testid": "video-banner-video-testid",
          "data-pod-name": "commerce",
          onLoadedData: I,
          children: /* @__PURE__ */ t("source", { src: e.backgroundVideoUrl })
        }
      )
    ] }),
    !n && /* @__PURE__ */ i("div", { className: `${a["video-banner-bottom-content-container"]} ${a[S]}`, children: [
      /* @__PURE__ */ i("div", { className: a["video-banner-details"], children: [
        (o == null ? void 0 : o.url) && /* @__PURE__ */ t("div", { className: a["video-banner-logo-container"], "data-testid": "video-banner-logo-container-testid", "data-pod-name": "commerce", children: /* @__PURE__ */ t(
          z,
          {
            className: a["video-banner-logo"],
            src: (o == null ? void 0 : o.url) ?? "",
            alt: (o == null ? void 0 : o.altText) ?? ""
          }
        ) }),
        (e == null ? void 0 : e.brandTagLine) && /* @__PURE__ */ t("h6", { className: a["video-banner-title"], children: e == null ? void 0 : e.brandTagLine })
      ] }),
      /* @__PURE__ */ i("div", { className: a["video-banner-footer-button"], children: [
        e.videoModalData.videoSection ? /* @__PURE__ */ t(
          C,
          {
            title: e.watchVideoText,
            buttonStyle: y.OUTLINE,
            theme: G.WHITE,
            size: v.MEDIUM,
            icon: { iconName: "play" },
            iconPosition: M.LEFT,
            onClick: m,
            "data-testid": "video-banner-watch-button-testid",
            "data-pod-name": "commerce",
            buttonWidth: s ? r.FULL_WIDTH : r.FIT_CONTENT
          }
        ) : "",
        /* @__PURE__ */ t(
          E,
          {
            target: (k = e == null ? void 0 : e.shopNow) == null ? void 0 : k.target,
            href: (u = e == null ? void 0 : e.shopNow) == null ? void 0 : u.url,
            forceNative: !1,
            children: /* @__PURE__ */ t(
              C,
              {
                title: (f = e == null ? void 0 : e.shopNow) == null ? void 0 : f.text,
                buttonStyle: y.SOLID,
                theme: G.WHITE,
                size: v.MEDIUM,
                "data-testid": "video-banner-shop-button-testid",
                "data-pod-name": "commerce",
                buttonWidth: s ? r.FULL_WIDTH : r.FIT_CONTENT
              }
            )
          }
        )
      ] })
    ] }),
    g ? /* @__PURE__ */ t(x, { elementId: "react-portal-modal", customStyles: !1, children: /* @__PURE__ */ t(U, { onClose: m, videoSection: e.videoModalData.videoSection }) }) : ""
  ] });
};
export {
  Oe as default
};
//# sourceMappingURL=VideoBanner.js.map
